import { render, staticRenderFns } from "./DetailDebtReport.vue?vue&type=template&id=cd0d0796"
import script from "./DetailDebtReport.vue?vue&type=script&lang=js"
export * from "./DetailDebtReport.vue?vue&type=script&lang=js"
import style0 from "./DetailDebtReport.vue?vue&type=style&index=0&id=cd0d0796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports